// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__1-OuI","tournamentName":"Placeholder_tournamentName__3Ti6w","badge":"Placeholder_badge__3iMTt"};